function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  className: "primary",
  d: "M24.7 34.7v6.6h-5.2v16.1h-7.9V19.1h7.9v15.6h5.2zM44.5 57.4h-7.9l6.7-38.3h2l2.1 17.6-1.4 10h2.6l.7 5.5h-4l-.8 5.2zM69.5 57.4h-7.9V19.1h7.9v38.3zM90.3 57.4h-7.9V19.1h7.9v38.3zM139.2 57.4h-7.9V19.1h7.9v38.3zM160.7 57.4h-7.9l6.7-38.3h2l2.1 17.6-1.3 10h2.6l.7 5.5h-4l-.9 5.2zM185.7 57.4h-7.9V19.1h7.9v38.3zM210.5 57.4h-7.9V19.1h7.9V57.4zM233 57.4h-7.9V19.1h7.9v38.3zM103.2 35.3h23.1v5.5h-23.1v-5.5z"
});

var _ref3 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("path", {
  className: "secondary",
  d: "M24.7 19.1h7.9v38.3h-7.9V41.3h-.1v-6.6h.1V19.1zM47.3 36.7l-2.1-17.6h6l6.4 38.3h-7.7l-.7-5.3-.7-5.5-1.2-9.9zM69.5 49.8h8.4v7.7h-8.4v-7.7zM90.3 26.8v-7.7h8.4v7.7h-8.4zm0 15.8V36H97v6.6h-6.7zM139.2 26.8v-7.7h1.7c5.3 0 9.6 4.2 9.6 9.4v2.4c-.2 5.7-3.9 7.1-3.9 7.1s3.8 1.4 3.9 7.1v3c0 5.1-4.3 9.4-9.6 9.4h-1.7V50h1.4c1.5 0 2.6-1.1 2.6-2.6v-3.6c0-1.4-1.2-2.6-2.6-2.6h-1.4v-6.5h1.4c1.5 0 2.6-1.1 2.6-2.6V29c0-1.4-1.2-2.2-2.6-2.2h-1.4zM163.6 36.7l-2.1-17.6h6l6.4 38.3h-7.7l-.7-5.3-.7-5.5-1.2-9.9zM185.7 43.2v-9.9l4.3-14.1h8.2l-6.4 19 6.5 19.3h-8.2l-4.4-14.3zM210.5 26.8v-7.7h8.4v7.7h-8.4zm0 14.5v-6.6h6.7v6.6h-6.7zm0 16.1v-7.7h8.4v7.7h-8.4zM233 26.6v-7.5h1.7c5.3 0 9.6 4.2 9.6 9.4v19.6c0 5.1-4.3 9.4-9.6 9.4H233V50h2c1.1 0 2-.9 2-1.9V28.7c0-1.1-.9-2-2-2-1.1-.1-2-.1-2-.1z"
}));

var SvgHalfBaked = function SvgHalfBaked(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    x: 0,
    y: 0,
    viewBox: "0 0 254.9 78.4",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgHalfBaked, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/half-baked.ac14c436.svg";
export { ForwardRef as ReactComponent };